var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextAttachment = function SvgTextAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8,44 L8,4 L28.544,4 L40,15.333 L40,44 L8,44 Z M26,13 L14,13 L14,14 L26,14 L26,13 Z M34,17 L14,17 L14,18 L34,18 L34,17 Z M14,21 L14,22 L34,22 L34,21 L14,21 Z M34,25 L14,25 L14,26 L34,26 L34,25 Z M34,29 L14,29 L14,30 L34,30 L34,29 Z M34,33 L14,33 L14,34 L34,34 L34,33 Z M34,37 L14,37 L14,38 L34,38 L34,37 Z"
  })));
};
export default SvgTextAttachment;